import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core'
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { ApiServiceBase } from '../../base/api-service-base';
import { AuthService } from '../../authentication/auth.service';

import { LanguageReferenceModel } from '../../models/reference-model/reference-general-model';

@Injectable({
    providedIn: 'root'
})
export class LanguageReferenceService extends ApiServiceBase {
    private readonly PATH = "/system/LanguageReferences"

    constructor(httpClient: HttpClient,
        authService: AuthService) {
        super(httpClient, authService);
    }

    public getLanguageReferences(): Observable<LanguageReferenceModel[]> {
        return this.httpGet<LanguageReferenceModel[]>(this.PATH, null)
            .pipe(
                map(res => res.body)
            )
    }

    public getLogonLanguageReferences(): Observable<LanguageReferenceModel[]> {
        return this.httpGet<LanguageReferenceModel[]>(this.PATH + '/logon', null)
            .pipe(
                map(res => res.body)
            )
    }
}